import React from "react";
import {
  otpRegister,
  validateOtpRegister,
  loginPassword
} from "../../services/rest";
import ReCaptcha from "../common/recaptcha.component";
import Validator from "../../utils/Validator";
import { toast } from "react-toastify";
import {
  OTP_VALIDATION_ERROR,
  RETRY_CAPTCHA_MESSAGE
} from "../../utils/constants";
import ToolTip from "../Login/ToolTip";
import "react-toastify/dist/ReactToastify.css";
import VodCookieGenerator from "../../utils/vod-cookie-generator";
import ErrorHandler from "../../utils/error-handler";
import TaggingHelper from "../../tagging/tagging-helper";
import OtpInput from "../common/OtpInput/OtpInput";

toast.configure();
class RegistrationOtp extends React.Component {
  defaultState = {
    recaptcha: null,
    otp: "",
    inValidOtp: true,
    showRecaptcha: false,
    message: "",
    previousPropData: null
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = {
        ...this.defaultState,
        recaptcha: props.data.currentState.token,
        showRecaptcha: false,
        message: props.data.message,
        previousPropData: props.data.currentState
      };
    }
  }

  componentDidMount() {
    if (this.props.data && this.props.data.text === "GET NEW OTP") {
      this.resendVerificationLink();
    }
    TaggingHelper.registrationOTPLandingEvent();
  }

  componentWillUnmount() {
    TaggingHelper.resetRegistrationOTPCahce();
  }

  _onOtpChange = (otpValue) => {
    // Called on every change; otpValue is the full OTP string from OtpInput
    this.setState({
      inValidOtp: this.inValidOtpDigit(otpValue),
      otp: otpValue
    });
  };

  _onOtpComplete = (otpValue) => {
    // Called when user finishes entering OTP
    this.setState({
      inValidOtp: this.inValidOtpDigit(otpValue),
      otp: otpValue
    });
    TaggingHelper.registrationOTPFormEditEvent();
  };

  _onVerifyCallback = (recaptcha) => {
    this.setState({ recaptcha, showRecaptcha: false });
    this.resendVerificationLink();
  };

  _onExpiredCallback = () => {
    this.setState({ recaptcha: null, showRecaptcha: true });
  };

  displayCaptcha = () => {
    this.setState({ recaptcha: null, showRecaptcha: true });
  };

  inValidOtpDigit = (otp) => {
    return !Validator.isValidOtp(otp);
  };

  notify = (message) => {
    toast.dismiss();
    toast.success(message, { position: toast.POSITION.BOTTOM_LEFT });
  };

  onOtpLogin = (e) => {
    e.preventDefault();
    const { goto } = this.props;
    const { username, cellnum } = this.state.previousPropData.previousPropData;
    this.props.showUILoader(true);
    TaggingHelper.registrationOTPCaptureEvent();
    validateOtpRegister(username, cellnum, this.state.otp)
      .then((response) => {
        if (response.data && response.data.result && response.status === 200) {
          const successMessage = response.data.result.message || "";
          this.handleSoftLogin(successMessage);
          TaggingHelper.registrationSuccessEvent();
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleValidateOtpRegisterApiError(
          error,
          goto,
          this.state,
          "REGISTRATION_OTP",
          this.state.previousPropData.previousPropData
        );
        this.props.showUILoader(false);
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.registrationErrorEvent(errorMessage);
      });
  };

  handleSoftLogin = (registrationSuccessMessage) => {
    const { username } = this.state.previousPropData.previousPropData;
    const { password } = this.state.previousPropData;
    const { redirectUrl, goto } = this.props;
    loginPassword(username, password, redirectUrl)
      .then((loginResponse) => {
        if (loginResponse.data && loginResponse.data.result) {
          TaggingHelper.loginPasswordSuccessEvent();
          const targetUrl =
            process.env.REACT_APP_BASE_URL + loginResponse.data.result.redirect;
          if (redirectUrl) {
            VodCookieGenerator.setVodaCookie("login-ui-redirection", targetUrl);
          }
          window.location.href = targetUrl;
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((loginError) => {
        const errorMessage = ErrorHandler.getErrorMessage(loginError)
          .errorMessage;
        TaggingHelper.loginApiErrorEvent(errorMessage);
        goto("LOGIN", { toastMessage: registrationSuccessMessage });
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  resendVerificationLink = () => {
    this.props.showUILoader(true);
    const {
      username,
      name,
      cellnum
    } = this.state.previousPropData.previousPropData;
    const { password } = this.state.previousPropData;
    const token = this.state.recaptcha;
    otpRegister(username, name, cellnum, password, token)
      .then((response) => {
        if (response.data && response.data.result && response.status === 200) {
          const message = response.data.result.message || "";
          this.notify(message);
          TaggingHelper.registrationOTPResentEvent();
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        const furtherActionFlag = ErrorHandler.handleResendOtpError(
          error,
          this.notify,
          this.displayCaptcha
        );
        if (furtherActionFlag) {
          ErrorHandler.handleApiError(
            error,
            this.props.goto,
            this.state.previousPropData.previousPropData,
            "CREATE_PROFILE"
          );
        }
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.registrationErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  onGoBack = () => {
    this.props.goto("CREATE_PASSWORD", {
      previousState: this.state.previousPropData
    });
  };

  formatMessageWithBoldMsisdn = (message) => {
    const msisdnPattern = /(\d{2,3}\*+\d{2,3})/;
    const match = message.match(msisdnPattern);
    
    if (match) {
      const parts = message.split(match[0]);
      return (
        <>
          {parts[0]}<strong>{match[0]}</strong>{parts[1]}
        </>
      );
    }
    return message;
  };

  render() {
    const { showRecaptcha, otp, inValidOtp, message } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Enter your OTP</h2>
          <p>{this.formatMessageWithBoldMsisdn(message)}</p>
        </div>
        <div className="field-group otp-field-group">
          <label className="active">{"OTP"}</label>
          <OtpInput
            length={6}
            onChange={this._onOtpChange}
            onComplete={this._onOtpComplete}
            hasError={otp.length === 6 && inValidOtp}
            autoFocus={true}
            isMasked={true}
            maskDelay={0}
          />
          {otp.length === 6 && inValidOtp && (
            <p className="infield-error-label">{OTP_VALIDATION_ERROR}</p>
          )}
        </div>
        <div className="action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={inValidOtp}
            onClick={(e) => this.onOtpLogin(e)}
            automationid="REGISTRATION_FORM_REGISTRATIONOTP_2"
          >
            NEXT
          </button>
        </div>
        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite"
            automationid="REGISTRATION_FORM_REGISTRATIONOTP_3"
            onClick={this.onGoBack}
          >
            Back
          </button>
        </div>
        {showRecaptcha && (
          <div className="captcha-wrapper">
            <ReCaptcha
              sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
              verifyCallback={this._onVerifyCallback}
              expiredCallback={this._onExpiredCallback}
            />
          </div>
        )}
        <div className="card-footer">
          <p>
            {"Haven't received anything? "}
            <button
              type="button"
              className={`button-link ${
                showRecaptcha ? "button-link-disabled" : ""
              }`}
              automationid="REGISTRATION_FORM_REGISTRATIONOTP_4"
              onClick={this.resendVerificationLink}
            >
              {`  Resend OTP `}
            </button>
            {showRecaptcha && (
              <ToolTip
                tooltip_message={RETRY_CAPTCHA_MESSAGE}
                position={`top`}
              />
            )}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default RegistrationOtp;
